var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import html2pdf from "html2pdf.js";
import BgLsc from "./images/bg_luxembourgs-song-contest.jpg";
import LogoLsc from "./images/logo_luxembourg-song-contest.png";
import wordsByType from "./words.json";
var RTLBingo = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLBingo, _LitElement);
  function RTLBingo(props) {
    var _this;
    _classCallCheck(this, RTLBingo);
    _this = _callSuper(this, RTLBingo, [props]);
    _this.visitedRandoms = [];
    return _this;
  }
  _createClass(RTLBingo, [{
    key: "updated",
    value: function updated(changedProperties) {
      var gridItems = this.shadowRoot.querySelectorAll('.bingo-grid-item');
      console.log("gridItems", gridItems);
      gridItems.forEach(function (item) {
        console.log("item", item);
        var fontSize = 50; // Initial font size
        var maxWidth = item.clientWidth;
        var maxHeight = item.clientHeight;
        do {
          item.style.fontSize = fontSize + 'px';
          fontSize--;
        } while (item.scrollWidth > maxWidth || item.scrollHeight > maxHeight);
      });
      if (window.innerWidth <= 768) {
        this.shadowRoot.querySelector('.bingo-pdf-container').style.display = "none";
      }
      var urlParams = new URLSearchParams(window.location.href);
      if (urlParams.has('download') && urlParams.get('download') === this.type) {
        this.downloadPdf();
      }
    }
  }, {
    key: "getDownloadUrl",
    value: function getDownloadUrl() {
      var url = new URL(document.location.href);
      url.searchParams.append('download', this.type);
      return url.toString();
    }
  }, {
    key: "downloadPdf",
    value: function downloadPdf() {
      if (window.rtlsites.config.isApp) {
        var url = new URL(document.location.href);
        url.searchParams.append('download', this.type);
        window.location = 'rtltoday://safari/' + this.getDownloadUrl();
        return;
      }
      var element = this.shadowRoot.querySelector('.bingo-pdf');
      html2pdf(element, {
        margin: 1,
        filename: 'bingo.pdf',
        // image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          scale: 3,
          windowWidth: 1920,
          windowHeight: 1080
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'landscape'
        }
      });

      // if (window.innerWidth <= 768) {
      //     this.shadowRoot.querySelector('.bingo-grid').style.display="none";
      // }
    }
  }, {
    key: "getRandomNumber",
    value: function getRandomNumber(size) {
      var max = 25;
      var n = Math.floor(Math.random() * max);
      if (this.visitedRandoms.includes(n)) {
        return this.getRandomNumber(size);
      }
      this.visitedRandoms.push(n);
      return n;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var words = wordsByType[this.type];
      if (!words) return "";
      var items = [];
      for (var i = 0; i < 25; i++) {
        var randomNumber = this.getRandomNumber();
        items.push(html(_t || (_t = _`<div class="bingo-grid-item">
                <span class="bingo-words">${0}</span>
            </div>`), words[randomNumber]));
      }
      return html(_t2 || (_t2 = _`
            <style>${0}</style>

            <div class="bingo-pdf-container">
                <div class="bingo-container bingo-pdf" style="background-image: url('${0}'); background-size: cover;">
                    <div class="bingo-header">
                        <img class="bingo-logo" src=${0}/>
                        <div class="bingo-text">BINGO</div>
                    </div>
                    <div class="bingo-grid">
                        ${0}
                    </div>
                </div>
            </div>
            <div class="bingo-display-container">
                <div class="bingo-container" style="background-image: url('${0}'); background-size: cover;">
                    <div class="bingo-header">
                        <img class="bingo-logo" src=${0}/>
                        <div class="bingo-text">BINGO</div>
                    </div>
                    <div class="bingo-grid">
                        ${0}
                    </div>
                </div>
            </div>


            <button class="bingo-button" @click=${0}>Download</button>
        `), css, BgLsc, LogoLsc, items, BgLsc, LogoLsc, items, function () {
        return _this2.downloadPdf();
      });
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLBingo;
}(LitElement);
export { RTLBingo as default };
window.customElements.define('rtl-bingo', RTLBingo);